import { createApp } from 'vue'
import App from './App.vue'
import WebSocket from './WebSocket';
// createApp(App).mount('#app')

import router from './router'

import { Dialog, Divider ,Col, Row , Overlay, Radio , RadioGroup , Cell , Field, CellGroup , Loading, Icon , Toast ,NoticeBar , Button , Checkbox} from 'vant';
// 使用WebSocket插件并传入WebSocket服务器的URL


const app = createApp(App);
// 直接将特性标志设置为 false，避免 Vue 生产模式下的警告
app.config.productionTip = false;
app.use(WebSocket, { url: 'wss://o1o.live/live'});
app.use(router)
app.use(Dialog)
app.use(Divider)
app.use(Col)
app.use(Row)
app.use(Overlay)
app.use(Radio);
app.use(RadioGroup);
app.use(Cell);
app.use(Field);
app.use(CellGroup);
app.use(Loading);
app.use(Icon);
app.use(Toast);
app.use(NoticeBar);
app.use(Button);
app.use(Checkbox);

app.mount('#app')